import React from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';

import { JoinedSessionDetailsItem } from 'queries/groups';

import { Card } from 'styles/shared';
import { colors, Fonts, spacing, transparencies } from 'styles/theme';

export interface SessionDetailsItem extends JoinedSessionDetailsItem {
    sessionNumber: number;
    isBanked: boolean;
}

export const getSessionItemKey = (item: SessionDetailsItem | null) =>
    item == null
        ? ''
        : `${item.id}-${item.is_repeatable}-${item.sessionNumber}-${item.isBanked}`;

interface SortableSessionItemProps {
    item: SessionDetailsItem;
    transparent?: boolean;
    isHighlighted?: boolean;
    isDimmed?: boolean;
}

export const SortableSessionItem = ({
    item,
    transparent = false,
    isHighlighted = false,
    isDimmed = false,
}: SortableSessionItemProps) => {
    const key = getSessionItemKey(item);
    const { attributes, listeners, setNodeRef, transform, transition } =
        useSortable({ id: key });
    const style: React.CSSProperties = {
        transform: CSS.Transform.toString(transform),
        transition,
        opacity: transparent ? 0 : 1,
        border: isHighlighted ? `1px solid ${colors.grandGold}` : 'none',
        backgroundColor: isDimmed ? transparencies.darkJungle10 : colors.white,
        cursor: 'grab',
    };
    return (
        <Card
            {...attributes}
            {...listeners}
            ref={setNodeRef}
            style={style}
            $padding={spacing.xxSmall}
        >
            <Fonts.XSmall>{item.title}</Fonts.XSmall>
        </Card>
    );
};
